import * as React from 'react';
import { Query } from 'react-apollo';

import CsvValidationTable from 'admin/rostering/components/CsvValidationTable';
import ErrorReporter from 'app/components/ErrorReporter';
import { findMatching } from 'utils/arrayHelpers';
import CSV_VALIDATIONS_QUERY from 'admin/rostering/queries/CsvValidationsQuery.gql';
import { SyncType } from 'globalTypes';

import {
  CsvValidations as CsvValidationsData,
  CsvValidationsVariables,
} from 'admin/rostering/queries/__generated__/CsvValidations';

type Props = {
  orgUuid: string;
};

export default class CsvValidationTableContainer extends React.Component<Props> {
  render() {
    const { orgUuid } = this.props;

    return (
      <Query<CsvValidationsData, CsvValidationsVariables>
        query={CSV_VALIDATIONS_QUERY}
        variables={{
          organizationUuid: orgUuid,
        }}>
        {({ data, error, loading }) => {
          if (loading) {
            return null;
          }

          if (error) {
            return (
              <ErrorReporter
                error={error || 'CsvValidationTableContainer - graphql loading error'}
              />
            );
          }

          const organization = findMatching(data?.organizations, orgUuid, 'uuid');

          if (!organization) {
            console.error(
              'CsvValidationTableContainer - expected the provided org uuid to return a result'
            );
            return null;
          }

          if (!organization.sisSyncOverview?.districtStatus) {
            console.error(
              'CsvValidationTableContainer - expected the org to be a district and have a district status'
            );
            return null;
          }

          const {
            sisSyncOverview: { districtStatus },
          } = organization;

          return (
            <CsvValidationTable
              syncType={districtStatus.syncType as SyncType}
              validations={districtStatus.csvValidationStatuses}
            />
          );
        }}
      </Query>
    );
  }
}
